import axios from 'axios'
import * as auth_util from '../utils/auth_util.js'
import { HBNS_APP_ID, HBNS_PROJECTS, TOKEN_AUDIENCE, TOKEN_GEN_ENDPOINT, TOKEN_REFRESH_ENDPOINT, TOKEN_REVOKE_ENDPOINT } from '../utils/appconfig.js'
import { generateTraceId } from '../utils/service_util.js'


function delay(ms) {
  return new Promise(resolve => setTimeout(resolve, ms));
} 

export const request_access_token = async (username, password, onComplete, onError) => {
  const api_url = TOKEN_GEN_ENDPOINT
  const data = { projects: HBNS_PROJECTS, aud: TOKEN_AUDIENCE }
  const headers = {
    'HBNS-APP-ID': HBNS_APP_ID,
    'HBNS-TRACE-ID': generateTraceId(),
    'Authorization': auth_util.create_basic_auth(username, password)
  }

  try {
    // await delay(1000); // simulate network delay for testing loading states
    const response = await axios.post(api_url, data, { headers })
    onComplete(response.data)
  } catch (err) {
    var authError = null
    if (err.response) {
      if (err.response.status === 401) {
        authError = "error: incorrect login"
      } else if (err.response.status === 403) {
        authError = "error: permission denied"
      } else if (err.response.status && err.response.status > 200) {
        authError = `error: auth service responded with status ${err.response.status}`
      }
    } else {
      authError = `unexpected error: exception ${err.toString()}`
    }
    onError(authError)
  }
}



export const request_token_refresh = async (token, onComplete, onError) => {
  // await delay(1000); // simulate network delay for testing loading states
  const headers = {
    'HBNS-APP-ID': HBNS_APP_ID,
    'HBNS-TRACE-ID': generateTraceId(),
    'Authorization': `Bearer ${token}`
  }
  try {
    const response = await axios.post(TOKEN_REFRESH_ENDPOINT, {}, { headers })
    onComplete(response.data)
  } catch (err) {
    onError(err)
  }
}

export const request_token_revoke = async (token, onComplete, onError) => {
  const headers = {
    'HBNS-APP-ID': HBNS_APP_ID,
    'HBNS-TRACE-ID': generateTraceId(),
    'Authorization': `Bearer ${token}`
  }
  try {
    const response = await axios.post(TOKEN_REVOKE_ENDPOINT, null, { headers })
    onComplete(response.data)
  } catch (err) {
    onError(err)
  }
}


